/* eslint-disable no-unused-vars */
import React from "react";
import styled from "styled-components";
import {
  color as c,
  ColorProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  LayoutProps,
  layout,
} from "styled-system";

interface Props {
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type: string;
}
const Component = styled.input<any>`
  ${c}
  ${layout}
  ${typography}
  ${space}
  font-family: Montserrat, sans-serif;
  display: inline-block;
  ::placeholder {
    color: white;
  }
`;

export const SearchBox: React.FC<
  Props & LayoutProps & ColorProps & TypographyProps & SpaceProps
> = ({
  placeholder,
  value,
  type,
  onChange,

  ...props
}) => {
  return (
    <Component
      data-testid="SearchBox"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      type={type}
      {...props}
    />
  );
};
